import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { motion } from 'framer-motion';



const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
      light: '#e57373',
      text: '#000000'

    },
    secondary: {
      main: '#e0e0e0',
      light: '#ffffff',
      dark: '#aeaeae'
    },
    warning: {
      main: '#ff9100',
      light: '#ffc947'

    },
    error: {
      main: '#ff0000',

    }
  },
  components: {
    // Name of the component
    MuiLoadingButton: {
      defaultProps: {
        // The props to change the default for.
        // disableRipple: true, // No more ripple, on the whole application 💣!

      },
      styleOverrides: {
        loadingIndicator: {
          color: '#b71c1c',
        }
      },
    },
  },
});
const MotionLoadingButton = motion(LoadingButton);

const CustomButtonMui = React.forwardRef((pr, ref) => {
  const { children, ...props } = pr;
  return (
    <ThemeProvider theme={theme}>
      <MotionLoadingButton {...props} whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.1 }} ref={ref}>{children}</MotionLoadingButton>
    </ThemeProvider>
  )
});

export default motion(CustomButtonMui);
